import React, { useEffect, useState } from 'react';
import { Tag } from 'antd';
import StandardTable from '../../components/common/StandardTable';
import { fetchSqlData } from '../../services/api';
import dayjs from 'dayjs';

const ChemicalMaterialChangeHistory: React.FC = () => {
  const [logs, setLogs] = useState<any[]>([]);
  useEffect(() => {
    fetchSqlData('it_logs_tkf_admin').then((res) => {
      const filtered = (Array.isArray(res) ? res : res.data || []).filter(
        (log: any) => log.table_name === 'mat_chemical_material'
      );
      setLogs(filtered);
    });
  }, []);

  const columns = [
    {
      title: 'Tarih/Saat',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (val: string) => val ? dayjs(val).format('DD/MM/YYYY HH:mm') : '-',
    },
    {
      title: 'İşlem',
      dataIndex: 'action',
      key: 'action',
      render: (val: string) => <Tag color={val === 'INSERT' ? 'green' : val === 'DELETE' ? 'red' : 'blue'}>{val}</Tag>,
    },
    {
      title: 'Malzeme No',
      key: 'material_no',
      render: (_: any, record: any) => {
        const oldVal = record.old_values && record.old_values.material_no;
        let newVal = undefined;
        if (record.new_values) {
          try {
            newVal = JSON.parse(record.new_values).material_no;
          } catch {}
        }
        return newVal || oldVal || '-';
      },
    },
    {
      title: 'Önceki Quantity',
      key: 'old_quantity',
      render: (_: any, record: any) => record.old_values?.quantity ?? '-',
    },
    {
      title: 'Değişim',
      key: 'delta',
      render: (_: any, record: any) => {
        const oldQ = record.old_values?.quantity ?? 0;
        let newQ = undefined;
        if (record.new_values) {
          try {
            newQ = JSON.parse(record.new_values).quantity;
          } catch {}
        }
        if (typeof oldQ === 'number' && typeof newQ === 'number') {
          const diff = newQ - oldQ;
          return diff > 0 ? `+${diff}` : diff;
        }
        return '-';
      },
    },
    {
      title: 'Sonraki Quantity',
      key: 'new_quantity',
      render: (_: any, record: any) => {
        if (record.new_values) {
          try {
            return JSON.parse(record.new_values).quantity;
          } catch {}
        }
        return '-';
      },
    },
  ];

  return (
    <div>
      <h2>Kimyasal Malzeme Hareket Geçmişi</h2>
      <StandardTable columns={columns} dataSource={logs} rowKey="id" exportFileName="chemical_material_history" />
    </div>
  );
};

export default ChemicalMaterialChangeHistory; 